import { render, staticRenderFns } from "./JobInformationPage.vue?vue&type=template&id=f12cb64e&scoped=true&"
import script from "./JobInformationPage.vue?vue&type=script&lang=js&"
export * from "./JobInformationPage.vue?vue&type=script&lang=js&"
import style0 from "./JobInformationPage.vue?vue&type=style&index=0&id=f12cb64e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f12cb64e",
  null
  
)

export default component.exports